import React
    , {
    useContext,
    useState
} from "react";
import ElementRenderer
    from "../ElementRenderer";
import useRepeatables
    from "../../../hooks/useRepeatables";
import {FormData} from "../FormProvider";
import {
    Button,
} from "@mui/material";
import {
    DeleteOutlined,
    ReplayOutlined
} from "@mui/icons-material";
import IconButton
    from "@mui/material/IconButton";
import styled
    from 'styled-components';

const FormSubHeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
`;

const FormSubHeaderRowTitle = styled.header`
  font-size: 1.3rem;
`

const FormSubHeaderLegend = styled.legend`
  font-size: 18px;
  border: 0;
  margin: 0 0 20px;
  padding: 0;
`

const FormSubHeaderContainer = styled.div`
  padding: 1.5rem;
  background: white;
`

const FormSubHeader = ({
                           template,
                           defaultAnswer,
                       }) => {
    const {addChildFieldValues} = useRepeatables({
        template,
        defaultAnswer,
        childProperty: 'question',
        defaultRows: 1
    });

    let {
        state,
        dispatch,
        findAnswer
    } = useContext(FormData);

    const content = template?.content;
    const isRepeatable = content?.repeatable === true;
    const childFields = [];

    Object.keys(template?.question).map(key => {
        childFields.push(template?.question[key]);
    });

    const initialRowsState = [];

    if (Object.keys(state.values[template.id]).length > 0) {
        for (const [key, value] of Object.keys(state.values[template.id])) {
            initialRowsState.push({
                row: parseInt(key),
                children: [...childFields]
            })
        }
    }

    const [rows, setRows] = useState(initialRowsState.length > 0 ? initialRowsState : [{
        row: 0,
        children: [...childFields]
    }]);
    const [highestRow, setHighestRow] = useState(initialRowsState.length - 1);

    // const firstField = Object.values(childFields)[0];

    const renderRow = ({
                           row,
                           children
                       }) => {
        if (Array.isArray(children) && children.length > 0) {
            return children.map((childField, index) => {
                return <ElementRenderer subheaderRow={row} answerIndex={row} key={index} template={childField} defaultAnswer={defaultAnswer}/>
            });
        }
    }

    const handleAddRow = (e) => {
        e.preventDefault();

        setRows([...rows, {
            row: highestRow + 1,
            children: [...childFields]
        }]);

        // @TODO Dispatch add new values for all child fields and their children
        addChildFieldValues(template.question, highestRow + 1);

        setHighestRow(highestRow + 1);
    }

    return (
        <FormSubHeaderContainer className='fz-form-field-group'>
            <fieldset className='fz-form-fieldset fz-form-fieldset-subheader' id={template.id}>
                {template.content.value.length > 0 &&
                <FormSubHeaderLegend className='fz-form-legend fz-form-subheader'>{template.content.value}</FormSubHeaderLegend>}

                {Array.isArray(childFields) && childFields.length > 0 && (
                    <div>
                        {isRepeatable && (
                            <>
                                {rows.map((row, index) => (
                                    <div key={row.row}>
                                        <FormSubHeaderTitleContainer>
                                            <FormSubHeaderRowTitle className='fz-form-repeatable-header'>Item {index + 1}</FormSubHeaderRowTitle>
                                            <IconButton className="fz-form-button fz-form-repeatable-button fz-form-repeatable-delete-button fz-form-element-subheader-button"
                                                        sx={{backgroundColor: '#eee'}}
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            const newRows = [...rows];
                                                            newRows.splice(index, 1);
                                                            setRows(newRows);
                                                        }}><DeleteOutlined/></IconButton>
                                        </FormSubHeaderTitleContainer>

                                        {renderRow(row)}
                                    </div>
                                ))}

                                <div className="fz-form-repeatable-buttons">
                                    <Button startIcon={
                                        <ReplayOutlined/>} className='fz-form-button fz-form-repeatable-button fz-form-repeatable-add-button fz-form-element-subheader-button' onClick={handleAddRow}>{content?.repeatButtonName ?? 'Add Row'}</Button>
                                </div>
                            </>
                        )}

                        {!isRepeatable && childFields.map((childField, index) => {
                            return <ElementRenderer subheaderRow={0} key={index} template={childField} defaultAnswer={defaultAnswer}/>
                        })}
                    </div>
                )}
            </fieldset>
        </FormSubHeaderContainer>
    )
}

export default FormSubHeader;